// extracted by mini-css-extract-plugin
export default {"zoomModal":"XZ-z","image":"YZ-z","button":"ZZ-z","isOverlayShown":"_Z-z"};